import React from 'react';
import { observer } from 'src/utils/mobx-react';
import Header from 'src/components/Header';
import { LayoutWrapper, MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';
import { CasinoMenuItems } from 'src/components/CasinoPageNavigation/CasinoMenuItems';
import { CasinoPageContent } from 'src/domains/casino/pages/CasinoPageContent';

export const CasinoPages = observer('CasinoPages', (): React.ReactElement => {
    return (
        <LayoutWrapper>
            <Header />
            <MainContainer>
                <CasinoMenuItems />
                <CasinoPageContent />
            </MainContainer>
        </LayoutWrapper>
    );
});
